import { render, staticRenderFns } from "./TestView.vue?vue&type=template&id=0b056497&scoped=true&"
import script from "./TestView.vue?vue&type=script&lang=js&"
export * from "./TestView.vue?vue&type=script&lang=js&"
import style0 from "./TestView.vue?vue&type=style&index=0&id=0b056497&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b056497",
  null
  
)

export default component.exports